import * as Yup from "yup";

export const LoginSchema = Yup.object({
  usernameOrEmail: Yup.string().required("Username or Email is required"),
  password: Yup.string().required("Password is required"),
});

export const RegisterSchema = Yup.object({
  name: Yup.string().trim().required("Display Name is required"),
  username: Yup.string()
    .trim()
    .min(3, "At least 3 characters")
    .required("Username is required"),
  email: Yup.string()
    .trim()
    .email("Invalid email")
    .required("Email is required"),
  password: Yup.string()
    .min(8, "At least 8 characters")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
  purpose: Yup.string()
    .oneOf(
      ["super_admin", "solution_provider", "reseller"],
      "Please select a purpose",
    )
    .required("Please select a purpose"),
});

export const ChangePasswordSchema = Yup.object({
  currentPassword: Yup.string().required("Current password is required"),
  newPassword: Yup.string()
    .min(8, "At least 8 characters")
    .required("New password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm password is required"),
});

export const ResetPasswordSchema = Yup.object({
  password: Yup.string()
    .min(8, "At least 8 characters")
    .required("New password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
});
